jQuery(document).ready(commonInit);

function commonInit(){
	
	//don't load anything on init after this in admin editor
	if(jQuery('#wpwrap').length !== 0) return false;
	
	setupMobileMenu();
	setupColumns();
	setupSearch();
	setupScrollEvents();
	setupFancyFocus();
	setupAnchors();
	setupGFButtons();
	
}

function setupMobileMenu(){
	
	jQuery("#mobile-nav").mmenu({

	}, {

		classNames: {
			selected: "current-menu-item",
			fixedElements: {
				
				fixed: "mobile-sticky"
				
			}
			
		}
		
	});
	
}

function setupColumns(){
	
	jQuery('.wp-block-columns').each(function(){
		
		var current = jQuery(this);
		var columnCount = jQuery('> *', current).length;
		
		current.addClass('has-'+columnCount+'-columns');
		
	});
	
}

function setupSearch() {
	
	jQuery('#search-container').on('click', function(e){
		e.stopPropagation();
		jQuery('html').addClass('search-is-open');
		jQuery('#s').focus();
	});
	
	jQuery('html').on('click', function(){
		jQuery('html').removeClass('search-is-open');
	});
	
}

function setupScrollEvents() {
	
	jQuery(window).on('scroll', checkHeaderPosition);
	
	checkHeaderPosition(jQuery(window));
	
}

function checkHeaderPosition(current = jQuery(this)) {
	
	var current = jQuery(this);
	var html = jQuery('html');
	var offset = current.scrollTop();
	
	if(offset > 30) {
		html.addClass('not-top');
	} else {
		html.removeClass('not-top');
	}
	
}

function setupFancyFocus(){	
	
	var formElements = jQuery('input, textarea, select');
	
	formElements.on('focus', function() {
		jQuery(this).closest(".gfield").addClass('focus');
	});
	
	formElements.on('blur', function(){
		
		var listItem = jQuery(this);
		
		if (!listItem.val()) {
			listItem.closest(".gfield").removeClass('focus');
		}
		
	});
	
}

function setupAnchors() {
	
	jQuery('a.anchor[href^="#"]').on('click', function(e){
		
		var current = jQuery(this);
		var anchorElement = jQuery(current.attr('href'));
		var headerHeight = jQuery('header').length ? jQuery('header').height() : 0;
		
		jQuery('html, body').animate({scrollTop : (anchorElement.offset().top - headerHeight)}, 'slow');
		
		return false;
		
	});
	
}

function setupGFButtons() {
	
	jQuery(".gform-theme-button, .gform_button").wrap("<a class='plumb-button gf-within'></a>");
	
	jQuery("a.plumb-button.gf-within").on("click", function(){
		jQuery("> input", this).trigger("click");
	});
	
}
